import React from "react";
import styled, { useTheme } from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { getBoxShadow } from "@utils/product/productValidators";

const StoreCustomerAttributes = ({ attributes }: any) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  if (!attributes || Object.keys(attributes).length === 0) {
    return null;
  }

  return (
    <>
      <CardContainer>
        <StatusBottomContainer>
          {Object.entries(attributes)
            .filter(
              ([key, value]) =>
                key !== "Account Id" &&
                value !== "" &&
                value !== null &&
                value !== undefined
            )
            .map(([key, value]) => (
              <StoreAttributeContainer key={key}>
                <LeftText isMobile={theme.isMobile}>
                  <VDBText
                    type={
                      theme.isLargeScreen
                        ? typography["Body-R"]
                        : typography["Minor-R"]
                    }
                    color={theme["core-06"]}
                  >
                    {key ?? ""}
                  </VDBText>
                </LeftText>
                <RightText>
                  <VDBText
                    type={
                      theme.isLargeScreen
                        ? typography["Body-M"]
                        : typography["Minor-M"]
                    }
                    color={theme["core-05"]}
                  >
                    {value?.toString()}
                  </VDBText>
                </RightText>
              </StoreAttributeContainer>
            ))}
        </StatusBottomContainer>
      </CardContainer>
      <Spacer size={SpaceType.Double} />
    </>
  );
};

export default StoreCustomerAttributes;

const CardContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme["core-03"]};
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

const StatusBottomContainer = styled.View`
  padding-top: ${SpaceType.ExtraSmall}px;
  padding-bottom: ${SpaceType.Basic}px;
`;

const StoreAttributeContainer = styled.View`
  padding: ${SpaceType.ExtraSmall}px ${SpaceType.Double}px;
  flex-direction: row;
`;

const LeftText = styled.View<{
  isMobile?: boolean;
}>`
  width: ${({ isMobile }) => (isMobile ? 40 : 18)}%;
`;

const RightText = styled.View`
  max-width: 800px;
`;
